import classNames from 'classnames/bind';
import React from 'react';

import styles from './CompanyHeader.module.scss';

const cx = classNames.bind(styles);

interface CompanyHeaderProps {
  name: string;
  ticker: string | null;
  className?: string;
}

const CompanyHeader = ({ name, ticker, className }: CompanyHeaderProps): React.ReactElement => {
  return (
    <h1 className={cx('body', className)} data-testid="company-display-name">
      {name}
      {ticker && ` (${ticker})`}
    </h1>
  );
};

export default CompanyHeader;
